import Q0 from './Q0';

export default Q0;
